import React, { useEffect, useState } from "react";
import API from "../../api/axiosConfig";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Plus, Edit, Trash2, QrCode } from "lucide-react";
import CreateSedeModal from "../../components/modals/CreateSedeModal";
import SedeQRModal from "../../components/modals/SedeQRModal";

const getId = (obj) => obj?.id ?? obj?._id;

export default function CompanySedes() {
  const [sedes, setSedes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [qrSede, setQrSede] = useState(null);
  const [editingSede, setEditingSede] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const companyId = user?.company?.id ?? user?.company?._id;
  const navigate = useNavigate();

  const fetchSedes = async () => {
    try {
      const res = await API.get(`/sedes/company/${companyId}`);
      const raw = res.data?.data?.sedes ?? res.data?.sedes ?? res.data;
      setSedes(Array.isArray(raw) ? raw : []);
    } catch (err) {
      toast.error("Error al cargar las sedes");
      console.log(err);
    }
  };

  useEffect(() => { fetchSedes(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
const handleQR = (sede) => {
  setQrSede(sede);
  setShowQR(true);
};
  const handleEdit = (sede) => { setEditingSede(sede); setShowModal(true); };

  const handleDelete = async (sedeId) => {
    if (!window.confirm("¿Deseas eliminar esta sede?")) return;
    try {
      await API.delete(`/sedes/${sedeId}`);
      toast.success("Sede eliminada");
      fetchSedes();
    } catch (err) {
      toast.error("Error al eliminar sede");
    }
  };


  return (
    <div className="p-6 max-w-5xl mx-auto">
      <button onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-supernova-600 hover:text-supernova-800 mb-6 font-semibold transition">
        <ArrowLeft size={20} /> Volver
      </button>

      <h2 className="text-3xl font-bold mb-6 text-center">Sedes de la empresa</h2>

      <div className="flex justify-end mb-4">
        <button onClick={() => { setEditingSede(null); setShowModal(true); }}
          className="bg-supernova-500 hover:bg-supernova-700 text-white px-3 py-2 rounded-lg flex items-center gap-2 transition">
          <Plus size={16} /> Nueva Sede
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow border border-gray-200 overflow-hidden">
        {/* Mobile */}
        <div className="md:hidden p-4 space-y-4">
          {sedes.length === 0 ? (
            <div className="text-center text-gray-500 text-sm">No hay sedes registradas.</div>
          ) : (
            sedes.map((sede, index) => (
              <motion.div key={getId(sede)} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }} className="border rounded-xl p-4 shadow-sm">
                <div className="font-semibold text-gray-800 text-lg">{sede.name}</div>
                <div className="text-sm text-gray-600 mt-1">📍 {sede.address}</div>
                <div className="text-sm text-gray-600">✉️ {sede.email}</div>
                <div className="text-sm text-gray-600">📞 {sede.phone}</div>
                <div className="flex flex-wrap gap-2 mt-4">
                  <button onClick={() => handleEdit(sede)}
                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition">
                    <Edit size={16} /> Editar
                  </button>
                  <button onClick={() => handleQR(sede)}
                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-purple-600 border border-purple-600 rounded-lg hover:bg-purple-50 transition">
                    <QrCode size={16} /> QR
                  </button>
                  <button onClick={() => handleDelete(getId(sede))}
                    className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-red-600 border border-red-600 rounded-lg hover:bg-red-50 transition">
                    <Trash2 size={16} /> Eliminar
                  </button>
                </div>
              </motion.div>
            ))
          )}
        </div>

        {/* Desktop */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-supernova-100 text-gray-700">
              <tr>
                <th className="py-3 px-4">Nombre</th>
                <th className="py-3 px-4">Dirección</th>
                <th className="py-3 px-4">Correo</th>
                <th className="py-3 px-4">Teléfono</th>
                <th className="py-3 px-4">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {sedes.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-6 text-gray-500 text-sm">No hay sedes registradas.</td></tr>
              ) : (
                sedes.map((sede, index) => (
                  <motion.tr key={getId(sede)} initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }} className="border-t hover:bg-supernova-50">
                    <td className="py-3 px-4 font-medium text-gray-800">{sede.name}</td>
                    <td className="py-3 px-4 text-gray-600">{sede.address}</td>
                    <td className="py-3 px-4 text-gray-600">{sede.email}</td>
                    <td className="py-3 px-4 text-gray-600">{sede.phone}</td>
                    <td className="py-3 px-4">
                      <div className="flex gap-2">
                        <button onClick={() => handleEdit(sede)}
                          className="flex items-center gap-1 px-2 py-1 text-blue-600 border border-blue-600 rounded hover:bg-blue-50 transition">
                          <Edit size={16} /> Editar
                        </button>
                        <button onClick={() => handleQR(sede)}
                          className="flex items-center gap-1 px-2 py-1 text-purple-600 border border-purple-600 rounded hover:bg-purple-50 transition">
                          <QrCode size={16} /> QR
                        </button>
                        <button onClick={() => handleDelete(getId(sede))}
                          className="flex items-center gap-1 px-2 py-1 text-red-600 border border-red-600 rounded hover:bg-red-50 transition">
                          <Trash2 size={16} /> Eliminar
                        </button>
                      </div>
                    </td>
                  </motion.tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <CreateSedeModal
          companyId={companyId}
          onClose={() => setShowModal(false)}
          onSedeCreated={() => { setShowModal(false); fetchSedes(); }}
          sedeToEdit={editingSede}
        />
      )}

      {showQR && <SedeQRModal sede={qrSede} onClose={() => setShowQR(false)} />}
    </div>
  );
}
